module.exports = __webpack_public_path__ + "static/media/l28_thumb_even.4e03f452.jpg";